import { useState, useEffect } from "react";
import styled, { keyframes } from 'styled-components';
import { getRandomMessage } from "../../utils/loadingMessages";
import RandomGame from "../../component/games";

const cloudFloat = keyframes`
    0% {
        transform: translateX(540px);
        opacity: 0;
    }
    10% {
        opacity: 0.9;
    }
    90% {
        opacity: 0.9;
    }
    100% {
        transform: translateX(-200px);
        opacity: 0;
    }
`;

const beamRotate = keyframes`
    0% { transform: rotate(-12deg); }
    100% { transform: rotate(12deg); }
`

const Cloud = styled.img`
    width: 100%;
    max-width: 578px;
    position: absolute;
    left: 0;
    bottom: 74px;
    animation: ${cloudFloat} 30s linear infinite;

    @media(max-width : 1024px){
        max-width : 100.0000vw;
        bottom: 12.8906vw
    }

    @media(max-width : 520px){
        max-width: 111.1538vw;
        bottom: 14.2308vw;
    }
`;

const Beam = styled.img`
    width: 100%;
    max-width: 489px;
    position: absolute;
    right: 52px;
    top: 4px;
    transform-origin: right center;
    z-index: -1;
    animation: ${beamRotate} 6s ease-in-out infinite alternate;

    @media(max-width : 1024px){
        max-width : 100.0000vw;
        right: 9.2773vw;
        top: 0.3906vw;
    }

    @media(max-width : 520px){
        max-width: 94.0385vw;
        right: 10.0000vw;
        top: 0.7692vw;
    }
`

const GameSection = styled.div`
    position: absolute;
    top: 55%;
    left: 50%;
    transform: translateX(-50%);
    width: calc(100% - 40px);
    bottom: 20px;
    z-index: 100;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    margin :0 20px

    @media (max-width: 520px) {
        top: 50%;
        bottom: 3.8462vw;
        width: calc(100% - 7.6923vw);
        margin :0 3.8462vw
    }
`;

export default function Loading({Constellation}){
    const [message, setMessage] = useState(getRandomMessage());

    useEffect(() => {
        setMessage(getRandomMessage());
    }, []);

    return(
        <div className="loadingLightHouse">
            <div className="loadingLightHouse_inner">
                <div className="loadingLightHouse_content">
                    <img
                        src={process.env.PUBLIC_URL + '/lightHouseImg/loadingLightHouse.png'}
                        alt='로딩 중'
                    />
                    <div className="loading_text">
                        <h5 style={{ wordBreak: 'keep-all', lineHeight: '1.3' }}>{message}</h5>
                    </div>
                </div>

                <div className='lightHouseIllust'>
                    <div className='lightHouseIllust_inner'>
                        <Cloud src={process.env.PUBLIC_URL + '/lightHouseImg/cloud.png'} alt='cloud'/>
                        <img src={process.env.PUBLIC_URL + '/lightHouseImg/lightHouse.png'} alt='Light House' className='lightHouse' />
                        <Beam src={process.env.PUBLIC_URL + '/lightHouseImg/beam.png'} alt='beam'/>
                    </div>
                </div>

                <GameSection>
                    <RandomGame theme="lighthouse" />
                </GameSection>
            </div>
        </div>
    )
}
